import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@/shared/components/MaterialTableElements';

const rows = [
    { id: 'name', disablePadding: true, label: 'Name', sortable: true },
    { id: 'slug', disablePadding: false, label: 'Slug', sortable: true },
    { id: 'price', disablePadding: false, label: 'Price', sortable: true },
    { id: 'status', disablePadding: false, label: 'Status', sortable: true },
    { id: 'orderIndex', disablePadding: false, label: 'Order', sortable: true },
];

interface MatTableHeadProps {
    onRequestSort: (event: unknown, property: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
}

const MatTableHead = ({ order, orderBy, onRequestSort }: MatTableHeadProps) => {
    const rtl = useSelector((state: { rtl: { direction: string } }) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell
                        key={row.id}
                        align={rtl.direction === 'rtl' ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === row.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={(event) => onRequestSort(event, row.id)}
                            className="material-table__sort-label"
                            dir="ltr"
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
